import { useModalContext } from "../../../contexts/ModalContext"
import edit from '../../../assets/images/svg/edit'

const EditIconButton = () => {

    const { modalState, editModal } = useModalContext()

    return (
        modalState?.modalType !== "addWish" && <i id="editIcon" className="iconImgBtn left-14" onClick={editModal}>
            {edit}
        </i>
    )
}

export default EditIconButton